import { Link } from "react-router-dom";
import { vehicles } from "@/mocks/vehicles";

export default function VehiclesPreview() {
  const preview = vehicles.slice(0, 3);

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Compra-venta</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a1a1a] mt-3" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              VEHÍCULOS DISPONIBLES
            </h2>
            <p className="text-gray-500 text-sm mt-2 max-w-md">
              Furgonetas, camiones y vehículos comerciales seleccionados con garantía de calidad.
            </p>
          </div>
          <Link
            to="/vehiculos"
            className="inline-flex items-center gap-2 border-2 border-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white text-[#1a1a1a] font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Ver todos los vehículos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {preview.map((v) => (
            <div key={v.id} className="bg-[#f8f7f5] rounded-xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300 cursor-pointer">
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={v.image}
                  alt={`${v.brand} ${v.model}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {v.badge && (
                  <span className="absolute top-3 left-3 bg-[#FF6B35] text-white text-xs font-bold px-3 py-1 rounded-full">
                    {v.badge}
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-bold text-[#1a1a1a] text-lg">{v.brand} {v.model}</h3>
                <div className="flex items-center gap-3 mt-1 mb-3">
                  <span className="text-gray-400 text-xs flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {v.year}
                  </span>
                  <span className="text-gray-400 text-xs flex items-center gap-1">
                    <i className="ri-speed-line"></i> {v.km.toLocaleString()} km
                  </span>
                  <span className="text-gray-400 text-xs flex items-center gap-1">
                    <i className="ri-gas-station-line"></i> {v.fuel}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-extrabold text-[#FF6B35]">
                    {v.price.toLocaleString("de-DE")} €
                  </span>
                  <Link
                    to="/vehiculos"
                    className="bg-[#1a1a1a] hover:bg-[#FF6B35] text-white text-xs font-semibold px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Ver detalles
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
